import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/flexibleFitmentEngineWorkspaceCapability/domain/FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type FlexibleFitmentEngineWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.flexibleFitmentEngine> & {
    fixedUdoTemplates: {
        [FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey.fitmentNode]: {
            udoAdditionalColumnIds: {
                attributes: Uuid;
                displayName: Uuid;
                nodeType: Uuid;
                parentId: Uuid;
                status: Uuid;
            };
        };
        [FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey.compatibilityLink]: {
            udoAdditionalColumnIds: {
                masterNodeId: Uuid;
                productCatalogueId: Uuid;
                status: Uuid;
            };
        };
    };
};

export const flexibleFitmentEngineWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey.fitmentNode]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                parentId: uuidZodValidator,
                nodeType: uuidZodValidator,
                displayName: uuidZodValidator,
                attributes: uuidZodValidator,
            }),
        }),
        [FlexibleFitmentEngineWorkspaceCapabilityUdoTemplateKey.compatibilityLink]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({status: uuidZodValidator, productCatalogueId: uuidZodValidator, masterNodeId: uuidZodValidator}),
        }),
    }),
}) satisfies zod.ZodType<FlexibleFitmentEngineWorkspaceCapabilityUdoBindings>;
